interface StatusBadgeProps {
  status: string;
}

import ProfileVerificationStepper from "@/pages/profile-verification/ProfileVerificationStepper";

export default function StatusBadge({ status }: StatusBadgeProps) {
  return <ProfileVerificationStepper status={status} compact />;
}
